<template>
  <kb-container fluid class="top-padding bottom-padding no-horiz-padding">

    <div>
        <h2>Documents on Weaving, Textiles, Lace, and Related Topics</h2>
        <p>
            This is an extensive digital archive of weaving, lace, and textile material created by Ralph Griswold. We are pleased and honored to be able to provide this wonderful collection to the world's community of weavers, lacemakers, and other textile artists!
        </p>
    </div>

    <kb-button-group class=' bottom-padding'>
        <kb-dropdown variant='primary' right text="Explore Documents">
            <kb-dropdown-item to='/document-search/keyword'>Search by Keyword</kb-dropdown-item>
            <kb-dropdown-item to='/document-search/author'>List by Author</kb-dropdown-item>
            <kb-dropdown-item to='/document-search/publication'>List by Publication</kb-dropdown-item>
            <kb-dropdown-item to='/document-search/topic'>List by Topic</kb-dropdown-item>
            <kb-dropdown-item to='/document-search/language'>List by Language</kb-dropdown-item>
        </kb-dropdown>
    </kb-button-group>

    <share-button/>

    <div class="row top-padding">
        <div class="col-md-12">
            <router-link to='/'>
                <img :src='this.getSiteImageUrl("Swift.png")' />
            </router-link>
        </div>
    </div>

    <helpUsButton/>
    <mailChimpSignup/>
  </kb-container>

</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'
import helpUsButton from './HelpUsButton.vue'
import mediaService from '../mixins/mediaService.js'
import shareButton from './ShareButton.vue'
export default {
    mixins: [mediaService],
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        shareButton: shareButton
    },
    created() {
        this.$store.commit('setPageTitle', 'Textile Documents Archive')
    }
}
</script>

<style>
</style>
